import { Typography } from '@tradersclub/core-ui';

import * as S from './styles';

type BoxAuthProps = {
  code?: string | string[];
};

const BoxAuth: React.FC<BoxAuthProps> = ({ code, children }) => {
  let couponCode = code;

  if (code && typeof code !== `string` && code?.length > 1) [couponCode] = code;

  return (
    <>
      {!!couponCode && (
        <S.BoxCoupon padding={24} display="flex" alignItems="center" justifyContent="center">
          <Typography variant="h6" fontWeight="bold" style={{ color: `#fff` }}>
            {`Cupom ${couponCode}`}
          </Typography>
        </S.BoxCoupon>
      )}
      <S.Wrapper haveCoupon={!!couponCode}>{children}</S.Wrapper>
    </>
  );
};

export default BoxAuth;
